/************************************** THIRD-PARTY MODULES ***************************************/
import React from 'react';
import {isObservableArray, IObservableArray} from 'mobx';
import {ComponentEnhancer} from 'recompose';

/*************** VIEW ENHANCER UTILITIES (TO WRAP VIEWS WITH ENHANCER/"CONTAINER") ****************/
/**
 * Stateless functional component to wrap with enhancer
 */
export type View<Props> = (props: Props) => JSX.Element;

/**
 * Type for any view-wrapping function
 */
export type Enhancer<InjectProps, ProvideProps> = ComponentEnhancer<InjectProps, ProvideProps>;

// TODO Get rid of wrapView - it's pointless
/**
 *  Wraps given view w/ given enhancer, & emits resultant component factory (callable in JSX)
 *
 *  @def <I> Injected props (i.e. props the enhancer injects into the view)
 *  @def <P> Props to explicitly pass to view via parent component e.g. <MyComponent val="myVal"/>
 *  @param {Enhancer} enhancer Composed set of functions/HOCs to wrap view with
                               e.g.: compose(withLadda, withRouter, inject('config'))
 *  @param {View} view View component that gets wrapped by the enhancer
 *
 *  @return {React.SFC} Unrendered stateless functional component (An element factory)
 */
export function wrapView<I = {}, P = {}>(
    enhancer: Enhancer<I, P>,
    view: View<I & P>
): React.SFC<I & P> {
    const EnhancedView = (enhancer(view) as any) as React.SFC<any>;
    return EnhancedView;
}

/**
 * If given observable array, return value.peek(); otherwise just return value
 */
export const loggableObs = (val: any | IObservableArray<any>) =>
    isObservableArray(val) ? (val as IObservableArray<any>).peek() : val;

/***************************************** BARREL EXPORTS *****************************************/
export * from './mousetrap-with-plugins';
export * from './api-helpers';
export * from './route-helpers';
export * from './input-helpers';
export * from './jvlns-helpers';
export * from './cookie-helpers';
export * from './string-helpers';

import * as apiHelpers from './api-helpers';
export {apiHelpers};
